import { Box, Card, CardContent, Grid } from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import React, { useState } from 'react';
import * as Yup from 'yup';
import SVG from 'react-inlinesvg';
import { FormattedMessage } from 'react-intl';
import axios from 'axios';
import { toAbsoluteUrl } from '_metronic/_helpers';
import { baseUrl } from 'app/config/baseUrl';

export default function AddTariffPlanForm() {
  const [status, setStatus] = useState();
  const success = () => (
    <Box className="tenantwasadded">
      <div className="column-center">
        <span className="margin-top-50">
          <SVG src={toAbsoluteUrl('/media/svg/done.svg')} />
        </span>
        <p className="font-weight-bolder margin-top-50 font-16">
          <FormattedMessage id="TARIFF.ADDED" />
        </p>
      </div>
    </Box>
  );

  const error = () => (
    <Box className="tenantwasadded">
      <div className="column-center">
        <span className="margin-top-50">
          <SVG
            src={toAbsoluteUrl('/media/svg/Modal/deactivation-tenant.svg')}
          />
        </span>
        <p className="font-weight-bolder margin-top-50 font-16">
          <FormattedMessage id="TARIFF.WASNOT.ADDED" />
        </p>
      </div>
    </Box>
  );

  function check() {
    if (status === undefined) {
      return null;
    } else if (status === 200) {
      return success();
    } else {
      return error();
    }
  }

  return (
    <Card className="tariff-form-container">
      <CardContent>
        <FormikStepper
          className="userform"
          initialValues={{
            name: '',
            fixed: '',
            el_addon: ''
          }}
          onSubmit={values => {
            axios
              .post(`${baseUrl}/org/tariff`, values)
              .then(response => {
                setStatus(response.status);
              })
              .catch(e => {
                setStatus(e.response.status);
                console.log(e.response);
              });
          }}
        >
          <FormikStep
            validationSchema={Yup.object({
              name: Yup.string()
                .min(1, 'Too Short!')
                .required('Required'),
              fixed: Yup.string()
                .min(1, 'Too Short!')
                .required('Required'),
              el_addon: Yup.string()
                .min(1, 'Too Short!')
                .required('Required')
            })}
          >
            <Box paddingBottom={2}>
              <p className="input-p">
                <FormattedMessage id="NAME" />
              </p>
              <Field
                InputProps={{ disableUnderline: true }}
                className="usermodalinput"
                name="name"
                component={TextField}
              />
            </Box>
            <Box paddingBottom={2}>
              <p className="input-p">
                <FormattedMessage id="FIXED.COST" />
              </p>
              <Field
                InputProps={{ disableUnderline: true }}
                className="usermodalinput"
                name="fixed"
                component={TextField}
              />
            </Box>
            <Box paddingBottom={2}>
              <p className="input-p">
                <FormattedMessage id="ELECTRICITY.ADDON" />
              </p>
              <Field
                InputProps={{ disableUnderline: true }}
                className="usermodalinput"
                name="el_addon"
                component={TextField}
              />
            </Box>
          </FormikStep>
          <FormikStep>{check()}</FormikStep>
        </FormikStepper>
      </CardContent>
    </Card>
  );
}

export function FormikStep({ children }) {
  return <>{children}</>;
}

export function FormikStepper({ children, ...props }) {
  const childrenArray = React.Children.toArray(children);
  const [step, setStep] = useState(0);
  const currentChild = childrenArray[step];

  function isLastStep() {
    return step === 0;
  }

  return (
    <Formik
      {...props}
      validationSchema={currentChild.props.validationSchema}
      onSubmit={async (values, helpers) => {
        if (isLastStep()) {
          await props.onSubmit(values, helpers);
          setStep(s => s + 1);
        } else {
          setStep(s => s + 1);
          helpers.setTouched({});
        }
      }}
    >
      <Form autoComplete="off">
        {step < 1 ? (
          <div>
            <div className="d-flex justify-content-center">
              <SVG src={toAbsoluteUrl('/media/svg/Modal/enterdetails.svg')} />
            </div>
            <p className="enterdetailsmodal">
              <FormattedMessage id="ENTER.DETAILS" />
            </p>
            <hr className="width-100p" />
          </div>
        ) : null}
        {currentChild}
        <div className="margin-top-25">
          <Grid container spacing={2}>
            <Grid item>
              {step === 0 ? (
                <button className="form-next-button1" type="submit">
                  <FormattedMessage id="NEXT" />
                </button>
              ) : null}
            </Grid>
          </Grid>
        </div>
      </Form>
    </Formik>
  );
}
